import { useMemo } from "react";

import clsx from "clsx";
import { DocumentList } from "@/features/documents";

export const CreatorDocuments = ({ creator_id, className, ...props }) => {
  const classes = clsx("creator-documents", className);
  const filterParams = useMemo(() => {
    return {
      user_id: creator_id,
    };
  }, [creator_id]);
  return (
    <DocumentList
      filterParams={filterParams}
      creatorId={creator_id}
      className={classes}
      gridId="creator-documents"
      excludeDataSources={"creator"}
    />
  );
};
